<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import {getUserInfo} from '@/api/index'
export default {
  name: 'App',
  computed: {
    ...mapState(['bookId', 'bookInfo']),
  },
  watch: {
    '$route': {
      handler () {
        let _bookId = this.$route.query.bookId || ''
        let _goodsId = this.$route.query.goodsId || ''
        let _token = this.$route.query.token || ''
        let _token_now = window.localStorage.getItem('token') || ''
        if (_token && _token !== _token_now) {
          window.localStorage.setItem('token', _token)
          this.getUserInfo(_token)
        }
        if (_bookId) {
          if (_bookId === this.bookId && Object.keys(this.bookInfo).length) return
          this.bookInfoGetter({bookId: _bookId}).then(() => {
            window.top.changePageTitle && window.top.changePageTitle(this.bookInfo.bookName || '')
          })
          this.bookIdSetter(_bookId)
        }
        if (_goodsId) {
          this.goodsIdSetter(_goodsId)
        }
        // window.top.changePageTitle && window.top.changePageTitle(this.$route.meta?.title)
      },
      immediate: true
    }
  },
  mounted () {
    this.getUserInfo()
    this.$nextTick(() => {
      this.initPageSize()
      window.addEventListener('resize', this.initPageSize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.initPageSize)
  },
  methods: {
    ...mapMutations(['userInfoSetter', 'bookIdSetter', 'goodsIdSetter', 'pageSizeInfoSetter']),
    ...mapActions(['bookInfoGetter']),
    getUserInfo(token) {
      token = token || window.localStorage.getItem('token')
      if (!token) return
      getUserInfo().then((res) => {
        if (res.code ===0) {
          this.userInfoSetter(res.data)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    initPageSize() {
      let pageWidth = document.documentElement.clientWidth
      let pageHeight = document.documentElement.clientHeight
      let swiperWidth = Math.floor(pageWidth * 0.82 - pageHeight * 0.02)
      let swiperHeight = Math.floor(pageHeight * 0.7186)
      let ratio = 1
      this.pageSizeInfoSetter({width: swiperWidth, height: swiperHeight, ratio})
    }
  }
}
</script>
<style lang="less">
#app {
  // min-width: 1500px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
}
</style>
